import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Cursor from "./components/Cursor";

const rootElement = document.getElementById("root");

// ✅ Safety check (prevents your exact error)
if (!rootElement) {
  throw new Error("Root element not found! Make sure <div id='root'></div> exists in public/index.html");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Cursor />
    <App />
  </React.StrictMode>
);

reportWebVitals();
